import { DEFAULT_THEMES } from 'configs/constant';
export default {
    defaultIsDarkMode: false,
    defaultIsRTL: false,
    zIndex: DEFAULT_THEMES.Z_INDEX,
    appbar: DEFAULT_THEMES.APP_BAR
};
